import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  Action_GetAllRoleInUser
} from "actions/User/actionTypes";
import {
  Index_GetAllRoleInUserSuccess
} from "actions/User";
import userApi from "service/User/UserApi";
import { pushNotification } from "utils/notifications";




//Region api

function* Saga_GetAllRoleInUser(action) {
  try {
    const response = yield call(userApi.getAllRoleInUser, action.payload);
    if (response.data) {
      yield put(Index_GetAllRoleInUserSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}
//endregion api
//region watchAPI

function* watch_GetAllRoleInUser() {
  yield takeLatest(Action_GetAllRoleInUser, Saga_GetAllRoleInUser);
}
//endregion watchAPI

export default function* sagas() {
  yield all([ watch_GetAllRoleInUser()]);
}
